module.exports = __webpack_public_path__ + "static/599d0667.v5_banner2.png";